import { HttpClient } from '@angular/common/http';
import { Injectable, signal, inject, Signal } from '@angular/core';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { User } from '../interfaces/user.model';
import { ThemeService } from './theme.service';
import { AppSettings } from '../app.settings';

@Injectable({
    providedIn: 'root'
})
export class AuthenticationService {

    router = inject(Router);
    http = inject(HttpClient);
    jwtHelper = inject(JwtHelperService);

    themeService = inject(ThemeService);

    private userSubject: BehaviorSubject<User | undefined>;
    public user: Observable<User | undefined>;

    private _user = signal<User | undefined>(undefined);

    private statusSubject = new BehaviorSubject<boolean>(false);

    private apiEndpoint: string = AppSettings.settings.apiServer.backend;
    private refreshInterval: number = AppSettings.settings.refreshInterval;

    private refreshTokenTimeout: any;
    private loginState: boolean = false;

    private isAdmin = signal<boolean>(false);

    constructor() {
        this.userSubject = new BehaviorSubject<User | undefined>(undefined);
        this.user = this.userSubject.asObservable();
        // console.log(config);

        let token = this.getToken();
        if (token) {
            this.startRefreshTokenTimer();
        }
    }

    public get userValue(): User | undefined {
        return this.userSubject?.value;
    }

    public get getLoginState(): boolean {
        return this.loginState;
    }

    login(email: string, password: string) {

        return this.http.post<any>(`${this.apiEndpoint}/login`, { email, password }) // , { withCredentials: true }
            .pipe(map(user => {
                console.log("nach login!");

                console.log(user);

                this.themeService.switchTheme(user.userdata.defaultTheme);
                this.setToken(user.access_token);
                this.startRefreshTokenTimer();
                this.statusSubject.next(true);
                this.userSubject.next(user);
                this._user.set(user); //  Signal
                this.loginState = true;

                localStorage.setItem('username', user.userdata.user);
                localStorage.setItem('userid', user.userdata.userid);

                this.isAdmin.set(user.userdata.admin == "Y");

                console.log("isAdmin: " + this.isAdmin);

                return user;
            }));
    }

    get userIsAdmin(): Signal<boolean> {
        return this.isAdmin;
    }


    isAuthenticated(): boolean {
        const token = localStorage.getItem('auth_token');
        if (!token || this.jwtHelper.isTokenExpired(token)) {
            return false;
        }
        return true;
    }

    loadUserdata(): Observable<any> {

        return this.http.get<any>(`${this.apiEndpoint}/me`)
            .pipe(map(data => {
                console.log("Authentication::me");
                console.log(data);

                let userdata = data.data.userdata;

                console.log("Niederlasungid", userdata.niederlassung_id);

                this.userSubject.next(data.userdata);
                this.themeService.switchTheme(userdata["defaultTheme"]);
                this.statusSubject.next(true);

                localStorage.setItem('username', userdata.user);
                localStorage.setItem('userid', userdata.userid);
                localStorage.setItem('niederlassung_id', userdata.niederlassung_id);

                console.log("Gruppe: " + userdata.group);

                this.isAdmin.set((userdata.group == "Admin"));

                console.log("isAdmin: " + this.isAdmin);

                return <any>userdata;
            }));
    }

    processUsernData(user: User) {

    }

    getToken(): string | null {
        return localStorage.getItem('auth_token');
    }

    setToken(token: string): void {
        // console.log("setToken aufgerufen... " + token);
        localStorage.setItem("auth_token", token);
    }

    checkTokenIsValid() {
        const token = localStorage.getItem('auth_token');
        if (token && !this.jwtHelper.isTokenExpired(token)) {
            return true;
        } else {
            this.router.navigate(['/login']);
            return false;
        }
    }

    logout() {
        this.http.post<any>(`${this.apiEndpoint}/logout`, {}).subscribe(); // , { withCredentials: true }
        this.stopRefreshTokenTimer();
        localStorage.removeItem('auth_token');
        localStorage.removeItem('username');
        localStorage.removeItem('userid');

        this.userSubject.next(undefined);
        this.statusSubject.next(false);
        this.router.navigate(['/login']);
    }

    refreshToken() {
        console.log("refreshToken startet....");

        return this.http.post<any>(`${this.apiEndpoint}/refresh`, { "refresh": true, }) // , { withCredentials: true }
            .pipe(map((user) => {
                console.log("Refresh Token");
                console.log(user);
                this.userSubject.next(user);
                this.setToken(user.access_token);
                this.startRefreshTokenTimer();
                return user;
            }));
    }

    getStatus(): Observable<boolean> {
        let token = this.getToken();

        if (!this.jwtHelper.isTokenExpired(token, 5))
            this.statusSubject.next(true);
        else
            this.statusSubject.next(false);

        return this.statusSubject;
    }

    // helper methods



    private startRefreshTokenTimer() {
        console.log("start Refreshtimer");

        let token = this.getToken();

        if (token) {
            // console.log(token);
            // parse json object from base64 encoded jwt token
            const jwtToken = JSON.parse(atob(token.split('.')[1]));

            // set a timeout to refresh the token a minute before it expires
            const expires = new Date(jwtToken.exp * 1000);
            const timeout = this.refreshInterval * 1000; // expires.getTime() - Date.now() - (60);
            console.log("Timeout: " + timeout);
            this.refreshTokenTimeout = setTimeout(() => this.refreshToken().subscribe(), timeout);
        }
        else {
            this.router.navigate(["login"]);
        }
    }

    private stopRefreshTokenTimer() {
        clearTimeout(this.refreshTokenTimeout);
    }
}